import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import WhatsAppButton from "@/components/widgets/WhatsAppButton";
import LiveChat from "@/components/widgets/LiveChat";

export default function MarketingLayout({ children }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      {children}
      <Footer />
      <WhatsAppButton />
      <LiveChat />
    </div>
  );
}
